module.exports = __webpack_public_path__ + "static/media/montserrat-cyrillic-400-normal.9c4cf182.woff2";